import { useCallback, useMemo } from "react";
export var useSort = function (sortOptions, criteria, updateCriteria) {
    var _a = sortOptions || {}, getDefaultSortCriteria = _a.getDefaultSortCriteria, getSortFromCriteria = _a.getSortFromCriteria, getCriteriaFromSort = _a.getCriteriaFromSort;
    var sort = useMemo(function () { return getSortFromCriteria === null || getSortFromCriteria === void 0 ? void 0 : getSortFromCriteria(criteria); }, [getSortFromCriteria, criteria]);
    var setSort = useCallback(function (sort) {
        var criteria = getCriteriaFromSort === null || getCriteriaFromSort === void 0 ? void 0 : getCriteriaFromSort(sort);
        if (criteria) {
            updateCriteria(criteria);
        }
    }, [getCriteriaFromSort, updateCriteria]);
    var clearSort = useCallback(function () {
        if (getDefaultSortCriteria) {
            var defaultSortCriteria = getDefaultSortCriteria();
            defaultSortCriteria && updateCriteria(defaultSortCriteria);
        }
    }, [getDefaultSortCriteria, updateCriteria]);
    return { sort: sort, setSort: setSort, clearSort: clearSort };
};
//# sourceMappingURL=use-sort.js.map